<template>
  <!-- TODO: translations -->
  <div class="configurations-content">
    <div v-if="!$route.path.includes('edit') && !$route.path.includes('create')" class="sub-header">
      <b-container fluid>
        <appConfigurationsNav
          v-if="$route.name == 'configurations-legal-mentions'"
          :title="configurationsLegalMentionsTitle"
          :breadcrumb-last="configurationsLegalMentionsBreadcrumb"
        />
        <appConfigurationsNav
          v-else-if="$route.name == 'configurations-pdf'"
          :title="configurationsPdfConfTitle"
          :breadcrumb-last="configurationsPdfConfBreadcrumb"
        />
        <appConfigurationsNav
          v-else-if="$route.name == 'configurations-agency-lre'"
          :title="configurationsAgencyLreTitle"
          :breadcrumb-last="configurationsAgencyLreBreadcrumb"
        />
      </b-container>
    </div>

    <router-view />
  </div>
</template>

<script>
import appConfigurationsNav from "@/components/snippets/ConfigurationsNav";

export default {
  components: {
    appConfigurationsNav,
  },
  data() {
    return {
      configurationsLegalMentionsTitle: this.$t("configuration_settings.titleLegalMentions"),
      configurationsLegalMentionsBreadcrumb: this.$t("configuration_settings.titleLegalMentions"),
      configurationsPdfConfTitle: this.$t("configuration_settings.titlePdfSettings"),
      configurationsPdfConfBreadcrumb: this.$t("configuration_settings.titlePdfSettings"),
      configurationsAgencyLreTitle: this.$t("configuration_settings.titleAgencyLRESettings"),
      configurationsAgencyLreBreadcrumb: this.$t("configuration_settings.titleAgencyLRESettings"),
    };
  },
};
</script>
